import React from "react";
import { SEO, PersonalDetails, AdminLayout } from "../../../components";

const PersonalDetailsPage = () => {
  return (
    <>
      <SEO title="Personal Details" />
      <AdminLayout>
        <PersonalDetails />
      </AdminLayout>
    </>
  );
};

export default PersonalDetailsPage;
